"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factorsKits = exports.defFontSize = exports.removeOverlay = void 0;
exports.isClickOutside = isClickOutside;
exports.parseNotNaN = parseNotNaN;
exports.calcKits = calcKits;
exports.syncAriaStates = syncAriaStates;
exports.modelScripts = modelScripts;
var removeOverlay = function () {
    console.log("removing overlay...");
    document.querySelectorAll(".off-canvas").forEach(function (el) { return el.remove(); });
};
exports.removeOverlay = removeOverlay;
var prevClickAttempt, lastClickAttempt;
function isClickOutside(event, query) {
    try {
        lastClickAttempt = new Date();
        var el = document.querySelector(query);
        if (!el) {
            if (Math.abs(lastClickAttempt - prevClickAttempt) > 1000)
                throw new Error("Element for checking click coordinates not found");
            else
                return [false, false, false, false];
        }
        var rect = el.getBoundingClientRect();
        var clientX = event.clientX, clientY = event.clientY;
        prevClickAttempt = lastClickAttempt;
        return [
            clientX < rect.left,
            clientX > rect.right,
            clientY < rect.top,
            clientY > rect.bottom,
        ];
    }
    catch (e) {
        console.error("Error executing isClickOutside:\n".concat(e.message));
        prevClickAttempt = new Date();
        return [false, false, false, false];
    }
}
function parseNotNaN(iniVal, def, context, fixed) {
    if (def === void 0) { def = 0; }
    if (context === void 0) { context = "float"; }
    if (fixed === void 0) { fixed = 4; }
    var returnVal = 0;
    try {
        if (typeof iniVal !== "string")
            throw new Error("Failed to validate argument: iniVal must be a string.");
        if (typeof context !== "string")
            throw new Error("Failed to validate argument: context must be a string.");
        if (typeof def !== "number")
            throw new Error("Failed to validate argument: def must be a number.");
        if (typeof fixed !== "number")
            throw new Error("Failed to validate argument: fixed must be a number.");
        switch (context) {
            case "int":
                returnVal = parseInt(iniVal, 10) || def;
                if (!Number.isFinite(returnVal) ||
                    Number.isNaN(returnVal) ||
                    isNaN(returnVal))
                    returnVal = def;
                break;
            case "float":
                returnVal = parseFloat(parseFloat(iniVal).toFixed(fixed)) || def;
                if (!Number.isFinite(returnVal) || isNaN(returnVal))
                    returnVal = def;
                break;
            default:
                throw new Error("Context of parsing invalid.");
        }
        return returnVal || 0;
    }
    catch (e) {
        console.error("Error executing parseNotNaN:\n".concat(e.message));
        return returnVal || 0;
    }
}
exports.defFontSize = 16;
exports.factorsKits = new Map([
    [
        "coots",
        new Map([
            ["peat", 0.3],
            ["perlite", 0.3],
            ["earthworm_humus", 0.3],
            ["sw_flour", 0.01],
            ["neem_pie", 0.01],
            ["shell_ls", 0.01],
            ["agr_plaster", 0.01],
            ["basalt_rp", 0.03],
        ]),
    ],
    [
        "gynetcs",
        new Map([
            ["peat", 0.91],
            ["perlite", 0.091],
            ["earthworm_humus", 0.065],
            ["neem_pie", 0.00375],
            ["bokashi", 0.0638],
            ["basalt_rp", 0.0455],
            ["shell_ls", 0.0182],
            ["biochar", 0.0274],
            ["agr_plaster", 0.0184],
            ["nt_phosp", 0.0184],
        ]),
    ],
    [
        "matinho",
        new Map([
            ["peat", 0.35],
            ["perlite", 0.35],
            ["earthworm_humus", 0.35],
            ["neem_pie", 0.0084],
            ["bokashi", 0.025],
            ["basalt_rp", 0.0417],
            ["shell_ls", 0.0084],
            ["biochar", 0.025],
            ["sw_flour", 0.0042],
            ["cr_flour", 0.0042],
            ["agr_plaster", 0.0084],
        ]),
    ],
]);
function calcKits(v, g) {
    if (v === void 0) { v = "0"; }
    if (g === void 0) { g = "main"; }
    try {
        if (typeof v !== "string")
            throw new Error("Inadequate primitive type argumented to calcKits as value");
        var err_1 = "#ERRO";
        var v_n_1 = 0;
        if (v.length === 0) {
            err_1 = "Sem valor de solo!";
            v_n_1 = 0;
        }
        else
            v_n_1 = parseNotNaN(v.replace(/,/g, ".").replace(/[^0-9\.]/g, ""));
        console.log(v_n_1);
        if (!Number.isFinite(v_n_1)) {
            console.warn("Value parsed as Not Finite. Defaulting to -1.");
            v_n_1 = -1;
            err_1 = "Entrada inválida.";
        }
        if (typeof g !== "string")
            throw new Error("Inadequate primitive type argumented to calcKits as group");
        if (!(g === "main" || g === "coots" || g === "matinho" || g === "gynetcs")) {
            console.error("Inadequate string value argumented to calcKits as group. Defaulting to main.");
            g = "main";
        }
        var handleOperations_1 = function (ks, g) {
            try {
                if (!(ks instanceof HTMLElement))
                    throw new Error("Inadequate instance passed as Kit Section.");
                if (typeof g !== "string")
                    throw new Error("Inadequate primitive type passed as group");
                if (!(g === "main" || g === "coots" || g === "matinho" || g === "gynetcs"))
                    throw new Error("Inadequate string value argumented to calcKits as group. Defaulting to main.");
                var gM_1 = exports.factorsKits.get(g);
                if (!gM_1)
                    throw new Error("Failed to get Map for Group ".concat(g));
                var outps = ks.querySelectorAll(".calc-outp");
                if (outps.length === 0)
                    throw new Error("Failed to populate list of output elements");
                outps.forEach(function (o, i) {
                    try {
                        if (!(o instanceof HTMLElement))
                            throw new Error("Failed to validate instance of output element");
                        var rel = o.dataset.name;
                        if (!rel || rel === "") {
                            console.warn("Dataset for Element ".concat(o.id || "unidentified", " has no name property. Fallbacking to name if available, but this is not the adequate assignment."));
                            rel = o.name;
                        }
                        if (!rel || rel === "")
                            throw new Error("Failed to fetch operation name.");
                        var f = gM_1.get(rel);
                        if (!f)
                            throw new Error("Failed to get factor in Group ".concat(g, " Map"));
                        var res = Math.round(v_n_1 * f * Math.pow(10, 5)) / Math.pow(10, 5);
                        var resV = res > 0 ? res : err_1;
                        o.innerText = "".concat(resV.toLocaleString("pt-BR") || err_1);
                        if (o.innerText === err_1) {
                            o.classList.add("calc-alert");
                            var soil = document.getElementById("soilQuant");
                            if (soil) {
                                soil.style.borderColor = "#e52f1351";
                                soil.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center",
                                    inline: "center",
                                });
                                soil.ariaInvalid = "true";
                                setTimeout(function () {
                                    var soil = document.getElementById("soilQuant");
                                    if (soil)
                                        soil.ariaInvalid = "false";
                                }, 200);
                            }
                            setTimeout(function () {
                                if (o)
                                    o.classList.add("calc-fade");
                            }, 100);
                            setTimeout(function () {
                                if (o) {
                                    var soil_1 = document.getElementById("soilQuant");
                                    if (soil_1)
                                        soil_1.style.borderColor = "#ddd";
                                    o.classList.remove("calc-alert", "calc-fade");
                                    o.innerText = "";
                                }
                            }, 2000);
                        }
                    }
                    catch (e) {
                        console.error("Error executing iteration ".concat(i, ", output ").concat(o.id || "unidentified", ", ks ").concat(ks.id || ks.className || ks.tagName, ":\n").concat(e.message));
                        o instanceof HTMLElement
                            ? (o.innerText = err_1)
                            : (o.innerHTML = err_1);
                        if ((o instanceof HTMLElement && o.innerText === err_1) ||
                            o.innerHTML === err_1) {
                            o.classList.add("calc-alert");
                            var soil = document.getElementById("soilQuant");
                            if (soil) {
                                soil.style.borderColor = "#e52f1351";
                                soil.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center",
                                    inline: "center",
                                });
                                soil.ariaInvalid = "true";
                                setTimeout(function () {
                                    var soil = document.getElementById("soilQuant");
                                    if (soil)
                                        soil.ariaInvalid = "false";
                                }, 200);
                            }
                            setTimeout(function () {
                                if (o)
                                    o.classList.add("calc-fade");
                            }, 100);
                            setTimeout(function () {
                                if (o)
                                    o.classList.remove("calc-alert", "calc-fade");
                                var soil = document.getElementById("soilQuant");
                                if (soil)
                                    soil.style.borderColor = "#ddd";
                                o instanceof HTMLElement
                                    ? (o.innerText = "")
                                    : (o.innerHTML = "");
                            }, 2000);
                        }
                    }
                });
            }
            catch (e) {
                console.error("Error executing handleOperations for ".concat((ks === null || ks === void 0 ? void 0 : ks.id) || (ks === null || ks === void 0 ? void 0 : ks.className) || (ks === null || ks === void 0 ? void 0 : ks.tagName) || "undefined", ":m").concat(e.message));
            }
        };
        if (g === "main") {
            var kitSects = document.querySelectorAll(".kit-sect");
            var kitsWrapper = document.getElementById("kits-wrapper");
            if (kitSects.length === 0)
                throw new Error("Error populating list of Kits Sections.");
            if (kitsWrapper &&
                kitsWrapper.querySelectorAll("section").length !== kitSects.length)
                console.warn("Incompatible numer of sections in the Kits Wrapper and length of kit sections!");
            var grps = Array.from(kitSects)
                .map(function (ks) {
                return ks instanceof HTMLElement && ks.dataset.group
                    ? ks.dataset.group
                    : "";
            })
                .filter(function (g) { return g !== ""; });
            if (grps.length === 0)
                throw new Error("Error populating list of Group names.");
            if (grps.length !== kitSects.length)
                console.warn("Incompatible number of kit group names and length of kit sections list!");
            grps.forEach(function (g, i) {
                try {
                    var relG = document.querySelector(".kit-sect[data-group=\"".concat(g, "\"]"));
                    if (!(relG instanceof HTMLElement))
                        throw new Error("Failed to fetch related group.");
                    handleOperations_1(relG, g);
                }
                catch (e) {
                    console.error("Error executing iteration ".concat(i, ", group ").concat(g, " when handling calculations:\n").concat(e.message));
                }
            });
        }
        else {
            var grp = document.querySelector(".kit-sect[data-group=\"".concat(g, "\"]"));
            if (!(grp instanceof HTMLElement))
                throw new Error("Failed to fetch Kit Section using dataset group");
            handleOperations_1(grp, g);
        }
    }
    catch (e) {
        console.error("Error executing calcKits:\n".concat(e.message));
    }
}
function syncAriaStates(els) {
    if (els instanceof NodeList)
        els = Array.from(els);
    els = els.filter(function (el) { return el instanceof Element; });
    if (Array.isArray(els) &&
        els.length > 0 &&
        Array.from(els).every(function (el) { return el instanceof Element; })) {
        els.forEach(function (el) {
            var _a, _b;
            if (el instanceof HTMLHtmlElement ||
                el instanceof HTMLScriptElement ||
                el instanceof HTMLLinkElement ||
                el instanceof HTMLMetaElement ||
                el instanceof HTMLTitleElement ||
                el instanceof HTMLHeadElement ||
                (el.parentElement && el.parentElement instanceof HTMLHeadElement))
                return;
            if (el instanceof HTMLElement) {
                el.hidden && !el.focus
                    ? (el.ariaHidden = "true")
                    : (el.ariaHidden = "false");
                el.addEventListener("click", function () {
                    el.hidden && !el.focus
                        ? (el.ariaHidden = "true")
                        : (el.ariaHidden = "false");
                });
                if (el.classList.contains("poCaller")) {
                    el.ariaHasPopup = "menu";
                }
                if (el instanceof HTMLSelectElement ||
                    el instanceof HTMLInputElement ||
                    el instanceof HTMLTextAreaElement) {
                    if (el instanceof HTMLSelectElement) {
                        if (el.querySelectorAll("option").length > 0) {
                            el.querySelectorAll("option").forEach(function (option) {
                                option.selected
                                    ? (option.ariaSelected = "true")
                                    : (option.ariaSelected = "false");
                            });
                            el.addEventListener("change", function () {
                                el.querySelectorAll("option").forEach(function (option) {
                                    option.selected
                                        ? (option.ariaSelected = "true")
                                        : (option.ariaSelected = "false");
                                });
                            });
                        }
                        el.addEventListener("click", function () {
                            if (el.ariaExpanded === "false")
                                el.ariaExpanded = "true";
                            if (el.ariaExpanded === "true")
                                el.ariaExpanded = "false";
                        });
                    }
                    if (el instanceof HTMLInputElement ||
                        el instanceof HTMLTextAreaElement) {
                        if (el.placeholder && el.placeholder !== "")
                            el.ariaPlaceholder = el.placeholder;
                        if (el.type !== "radio") {
                            el.required
                                ? (el.ariaRequired = "true")
                                : (el.ariaRequired = "false");
                            !el.checkValidity()
                                ? (el.ariaInvalid = "true")
                                : (el.ariaInvalid = "false");
                            (_a = el.closest("form")) === null || _a === void 0 ? void 0 : _a.addEventListener("submit", function () {
                                !el.checkValidity()
                                    ? (el.ariaInvalid = "true")
                                    : (el.ariaInvalid = "false");
                            });
                        }
                        if (el instanceof HTMLTextAreaElement ||
                            (el instanceof HTMLInputElement &&
                                (el.type === "text" ||
                                    el.type === "tel" ||
                                    el.type === "email" ||
                                    el.type === "number" ||
                                    el.type === "date" ||
                                    el.type === "time" ||
                                    el.type === "password" ||
                                    el.type === "search" ||
                                    el.type === "month" ||
                                    el.type === "week"))) {
                            if (el instanceof HTMLInputElement &&
                                el.list &&
                                el.list.id !== "")
                                el.ariaAutoComplete = "list";
                            if (el instanceof HTMLInputElement &&
                                (el.type === "number" ||
                                    el.type === "date" ||
                                    el.type === "time")) {
                                el.ariaValueMax = el.max;
                                el.ariaValueMin = el.min;
                            }
                            if (el instanceof HTMLInputElement && el.type === "range") {
                                el.addEventListener("change", function () {
                                    el.ariaValueNow = el.value;
                                    el.ariaValueText = el.value;
                                });
                            }
                        }
                        else if (el instanceof HTMLInputElement &&
                            (el.type === "radio" || el.type === "checkbox")) {
                            el.checked
                                ? (el.ariaChecked = "true")
                                : (el.ariaChecked = "false");
                            el.disabled
                                ? (el.ariaDisabled = "true")
                                : (el.ariaDisabled = "false");
                            el.addEventListener("change", function () {
                                el.checked
                                    ? (el.ariaChecked = "true")
                                    : (el.ariaChecked = "false");
                                el.disabled
                                    ? (el.ariaDisabled = "true")
                                    : (el.ariaDisabled = "false");
                            });
                        }
                        else if (el instanceof HTMLInputElement &&
                            (el.type === "button" ||
                                el.type === "submit" ||
                                el.type === "reset")) {
                            el.addEventListener("mousedown", function (click) {
                                if (click.button === 0)
                                    el.ariaPressed = "true";
                            });
                            el.addEventListener("mouseup", function (release) {
                                if (release.button === 0)
                                    el.ariaPressed = "false";
                            });
                        }
                    }
                }
                if (el instanceof HTMLLabelElement) {
                    if (el.hasChildNodes() && el.firstChild instanceof Text) {
                        el.ariaLabel = el.firstChild.nodeValue;
                    }
                }
                if (el instanceof HTMLButtonElement) {
                    el.addEventListener("mousedown", function (click) {
                        if (click.button === 0)
                            el.ariaPressed = "true";
                    });
                    el.addEventListener("mouseup", function (release) {
                        if (release.button === 0)
                            el.ariaPressed = "false";
                    });
                    if ((_b = el.textContent) === null || _b === void 0 ? void 0 : _b.match(/consultar/gi)) {
                        el.ariaHasPopup = "dialog";
                    }
                }
                if (el instanceof HTMLDialogElement)
                    el.ariaModal = "true";
            }
        });
    }
}
function modelScripts() {
    var rex = /[\-\?\=\+\s\.\&\<\>\^\:~,\/\\@]/g;
    try {
        document.querySelectorAll("script").forEach(function (script, i) {
            try {
                if (!(script instanceof HTMLScriptElement))
                    return;
                if (script.type === "" && script.src !== "")
                    script.type = "text/javascript";
                if (script.id === "" && script.src !== "") {
                    var url = new URL(script.src);
                    script.id = url.pathname.replace(rex, "__");
                }
                if (script.crossOrigin === "")
                    script.crossOrigin = "anonymous";
            }
            catch (e) {
                console.error("Error executing iteration ".concat(i, " for <script> tags in modelScripts:\n").concat(e.message));
            }
        });
        document.querySelectorAll("link").forEach(function (link, i) {
            try {
                if (!(link instanceof HTMLLinkElement))
                    return;
                if (link.id === "" && link.href !== "") {
                    var url = new URL(link.href);
                    link.id = url.pathname.replace(rex, "__");
                }
                if (link.rel === "")
                    link.rel = "alternate";
                if (link.crossOrigin === "")
                    link.crossOrigin = "anonymous";
            }
            catch (e) {
                console.error("Error executing iteration ".concat(i, " for <link> tags in modelScripts:\n").concat(e.message));
            }
        });
        document.querySelectorAll("meta").forEach(function (meta, i) {
            try {
                if (!(meta instanceof HTMLMetaElement))
                    return;
                if (meta.id === "") {
                    if (meta.name && meta.name !== "") {
                        meta.id = meta.name.replace(rex, "__");
                        return;
                    }
                    if (meta.property && meta.property !== "") {
                        meta.id = meta.property.replace(rex, "__");
                        return;
                    }
                    if (meta.httpEquiv && meta.httpEquiv !== "") {
                        meta.id = meta.httpEquiv.replace(rex, "__");
                        return;
                    }
                    if (meta.content && meta.content !== "") {
                        meta.id = meta.content.replace(rex, "__");
                        return;
                    }
                    if (/charset/g.test(meta.outerHTML))
                        meta.id = "charset";
                }
            }
            catch (e) {
                console.error("Error executing iteration ".concat(i, " for identifying meta tag:\n").concat(e.message));
            }
        });
        document.querySelectorAll("style").forEach(function (style, i) {
            try {
                if (!(style instanceof HTMLStyleElement))
                    return;
                if (style.type !== "")
                    style.type = "";
                if (style.media === "all")
                    style.media = "";
                if (style.id === "") {
                    style.id = document.getElementById("__next")
                        ? "next_generated_style_".concat(i)
                        : "automatically_generated_style_".concat(i);
                    style.dataset.group = "automatic_name";
                }
            }
            catch (e) {
                console.error("Error executing iteration ".concat(i, " for <style> tags in modelScripts:\n").concat(e.message));
            }
        });
        document.querySelectorAll("a").forEach(function (a, i) {
            try {
                if (!(a instanceof HTMLAnchorElement))
                    return;
                if (a.href !== "" &&
                    !(new RegExp(location.hostname, "g").test(a.href) ||
                        /https/.test(a.href))) {
                    if (!/noopener/g.test(a.rel))
                        a.rel += " noopener";
                    if (!/noreferrer/g.test(a.rel))
                        a.rel += " noreferrer";
                }
            }
            catch (e) {
                console.error("Error executing iteration ".concat(i, " for <a> tags in modelScripts:\n").concat(e.message));
            }
        });
    }
    catch (e) {
        console.error("Error executing modelScripts:\n".concat(e.message));
    }
}
